import { Select } from "antd";

const { Option: ADOption } = Select;

export default ADOption;
